/**
 * PURPOSE: Inicializar Hayllis Legacy en modo público y forzar una experiencia visual clara.
 * RESPONSIBILITIES: Aplicar el tema claro, conectar Redux y montar la aplicación React.
 * COLLABORATORS: App.js, store, index.css y tailwind.config.js.
 * ROUTE: hayllis-legacy/src/index.js
 */

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import "./index.css";

const ACTIVE_THEME = "light";
const documentRoot = document.documentElement;
documentRoot.classList.remove("dark", "light");
documentRoot.classList.add(ACTIVE_THEME);
documentRoot.dataset.theme = ACTIVE_THEME;
documentRoot.style.colorScheme = ACTIVE_THEME;

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
